import React from 'react';
import { useTranslation } from 'react-i18next';
import { Clock } from 'lucide-react';
import { Badge } from '@/components/ui/badge';

const WaitlistPositionIndicator = ({ position, count }) => {
  const { t } = useTranslation();

  return (
    <Badge variant="outline" className="gap-1.5 text-amber-700 border-amber-300 bg-amber-50">
      <Clock className="h-3 w-3" />
      {t('funJumper.waitlist.position', { position, count })}
    </Badge>
  );
};

export default WaitlistPositionIndicator;
